import { useMemo, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { orderGridOpenMarkShippedModal } from '../../../store/orders/grid/orders.grid.header.actions';
import { BASE_MAS_PAGE } from '../../../orders/mark-as-shipped/constants';
import { useAdvancedSearchStatusDisabled } from '../disabled-hooks/use-advanced-search-status-disabled';
import { useOneOrMoreOrderSelectedDisabled } from '../disabled-hooks/use-one-or-more-order-selected-disabled';
import { messages } from './messages';

export const useAdvancedSearchMarkShipped = () => {
  const dispatch = useDispatch();
  const advancedSearchStatusDisabled = useAdvancedSearchStatusDisabled();
  const oneOrMoreOrderSelectedDisabled = useOneOrMoreOrderSelectedDisabled();

  const actionHandler = useCallback(() => {
    dispatch(orderGridOpenMarkShippedModal(BASE_MAS_PAGE));
  }, [dispatch]);

  return useMemo(() => {
    return {
      actionHandler,
      nameDescriptor: messages.orderGridOtherActionsMarkShipped,
      isDisabled: advancedSearchStatusDisabled || oneOrMoreOrderSelectedDisabled,
      disabledReason: null,
    };
  }, [actionHandler, advancedSearchStatusDisabled, oneOrMoreOrderSelectedDisabled]);
};
